<template>
  <q-slide-transition>
    <div v-if="open" class="row q-mt-md q-pa-sm q-col-gutter-sm">
      <template v-if="field.type !== 'html'">
        <div class="col-xs-12">
          <h4 class="no-margin"><small>Field settings</small></h4>
        </div>
        <div class="col-xs-12">
          <q-input v-model="fieldLabel" class="col-xs-12" label="Label" hint="The field title" outlined type="text" />
        </div>
        <div class="col-xs-12">
          <q-input
            v-if="!['q-option-group', 'q-select'].includes(field.tag)"
            v-model="fieldPlaceholder"
            label="Placeholder"
            hint="Filler text for the field which appears when clicking on the field and before typing any value"
            outlined
            type="text"
          />
        </div>
        <div class="col-xs-12">
          <q-input
            v-model="fieldHelper"
            label="Helper"
            hint="Appears below the field and can be used to give some field-related detail or guidance, like this text itself"
            outlined
            type="text"
          />
        </div>
        <div v-if="fieldOptions" class="col-xs-12 q-mt-md">
          <h4 class="no-margin"><small>Options</small></h4>
        </div>
        <div v-for="(option, index) of fieldOptions" :key="`option_set_${index}`" class="col-xs-12 no-margin">
          <div class="row no-margin items-center no-wrap">
            <q-input
              v-model="option.label"
              :autofocus="true"
              class="col on-right no-margin"
              stack-label
              label="Label"
              type="text"
              outlined
              @input="updateOption(index, $event)"
              @focus="selectValue($event)"
            />
            <div class="col-auto on-right self-end">
              <q-btn size="sm" color="negative" @click="removeOption(index)"><i class="fas fa-trash"/></q-btn>
            </div>
          </div>
        </div>
        <div v-if="fieldOptions" class="col-xs-12 text-right">
          <q-btn color="positive" @click="addOption">Add option <i class="fas fa-plus on-right"/></q-btn>
        </div>
      </template>
      <div v-if="field.type === 'html'" class="row">
        <h4 class="no-margin"><small>Custom Text Settings</small></h4>
        <div class="col-xs-12">
          <q-input
            v-model="fieldValue"
            :rows="3"
            stack-label
            label="Your custom text"
            class="lm-textarea"
            outlined
            type="textarea"
          />
        </div>
      </div>
    </div>
  </q-slide-transition>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  name: 'LmDraggableFormComponentSettings',
  props: {
    field: {
      type: Object,
      required: true
    },
    open: Boolean
  },

  computed: {
    fieldLabel: {
      get() {
        return this.field.settings.label
      },
      set(value) {
        this.$emit('update-field-settings', { prop: 'label', value })
      }
    },

    fieldPlaceholder: {
      get() {
        return this.field.settings.placeholder
      },
      set(value) {
        this.$emit('update-field-settings', { prop: 'placeholder', value })
      }
    },

    fieldValue: {
      get() {
        return this.field.settings.value
      },
      set(value) {
        this.$emit('update-field-settings', { prop: 'value', value })
      }
    },

    fieldHelper: {
      get() {
        return this.field.settings.helper
      },
      set(value) {
        this.$emit('update-field-settings', { prop: 'helper', value })
      }
    },

    fieldOptions: {
      get() {
        return cloneDeep(this.field.settings.options)
      },
      set(value) {
        this.$emit('update-field-settings', { prop: 'options', value })
      }
    }
  },
  methods: {
    addOption() {
      const options = cloneDeep(this.field.settings.options)
      options.push({
        label: 'New option',
        value: 'New option'
      })
      this.fieldOptions = options
    },
    removeOption(index) {
      const options = cloneDeep(this.field.settings.options)
      options.splice(index, 1)
      this.fieldOptions = options
    },
    updateOption(index, value) {
      const options = cloneDeep(this.field.settings.options)
      options[index] = {
        label: value,
        value: value
      }
      this.fieldOptions = options
    },
    selectValue(event) {
      event.target.select()
    }
  }
}
</script>
